
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      footerNav: "menus/getFooterNav",
      headerNav: "v2/nav/getFooterNav",
      seoTexts: "global/getSeoTexts",
      processedSeoTexts: "global/getProcessedSeoTexts",
      seoSettings: "global/getSeoSettings",
    }),
    isCatalog() {
      return this.$route.name.includes("catalog");
    },
    isProfilePage() {
      return this.$route.name == "profile-slug";
    },
    seoText() {
      return this.processedSeoTexts?.footer;
    },
    showBottomSeo() {
      return !(this.$route.query?.page && this.isCatalog);
    },
  },
};
